import { render, staticRenderFns } from "./OrderImageModal.vue?vue&type=template&id=3edd2fe2&scoped=true&"
import script from "./OrderImageModal.vue?vue&type=script&lang=js&"
export * from "./OrderImageModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderImageModal.vue?vue&type=style&index=0&id=3edd2fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd2fe2",
  null
  
)

export default component.exports